import { FaPen, FaTrash, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const SubCategoryTable = ({ subcategories = [], onEdit, onDelete, canWrite = true }) => {
    if (!subcategories || subcategories.length === 0) {
        return (
            <div className="no-variants-message">
                <p>No subcategories found for this category.</p>
            </div>
        );
    }

    return (
        <div className="luxury-table-container">
            <table className="luxury-table">
                <thead>
                    <tr>
                        <th>Subcategory Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {subcategories.map((sub) => {
                        // Check multiple potential status fields from API
                        const isActive = sub.status === true || 
                                         sub.sub_status === true || 
                                         sub.status === 1 || 
                                         sub.sub_status === 1 ||
                                         String(sub.status || sub.sub_status).toLowerCase() === 'true';

                        return (
                            <tr key={sub.subcategory_id || sub._id || sub.id}>
                                <td style={{ fontWeight: "700", color: "#181c32" }}>
                                    {sub.sub_category_name || sub.subcategory_name}
                                </td>
                                <td>
                                    <span className={`status-pill ${isActive ? 'active' : 'inactive'}`}>
                                        {isActive ? (
                                            <><FaCheckCircle size={12} /> Active</>
                                        ) : (
                                            <><FaTimesCircle size={12} /> Inactive</>
                                        )}
                                    </span>
                                </td>
                                <td>
                                    <div className="table-actions">
                                        {canWrite && (
                                            <>
                                                <button className="action-btn edit" onClick={() => onEdit(sub)} title="Edit">
                                                    <FaPen />
                                                </button>
                                                <button className="action-btn delete" onClick={() => onDelete(sub.subcategory_id || sub._id || sub.id)} title="Delete">
                                                    <FaTrash />
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default SubCategoryTable;
